<template>
  <div class="stmnt">
    <div v-if="selectedState === 'NonOpen'" class="head">
      <div class="inhead bordered clickable" @click="togglePickers()">
        <div>
          <span class="minittl">date range</span>
          <span class="ttl filtertgl">{{ historyDateRange.from | moment('MMM Do YYYY') }} - {{ historyDateRange.to | moment('MMM Do YYYY') }}</span>
        </div>
        <span class="pd-icon pd-icon-calendar"></span>
      </div>
    </div>
    <div v-if="1 === 2">
      x {{isGeolocated}} x| {{geolocationMessage}}<br />
      bbs: {{bbStatus}} | bbs.state: {{bbStatus.state}} | bb.bet: {{ bb.bet }}<br />
      cmp: {{ filterDateRange.from }} - {{ filterDateRange.to }}]
    </div>

    <div v-if="!isLoggedIn" class="stmnt-block note">{{ $t('Statement.LoginToSeeBetHistory') }}</div>
    <div class="stmnt-fdaterang-ri" v-if="isLoggedIn && (filterVisiblePicker == 'from' || filterVisiblePicker == 'to')">
      <div class="fdr-wrap">
        <div class="fdr-heading">
          <div class="stmnt-btnset x2 fullw">
            <div class="sbtnwrap"><button class="stmnt-btn datebtn" :class="{ 'active': filterVisiblePicker === 'from' }" @click="selectPicker('from')"><span class="headhint">{{ $t('Statement.daterange.from') }}</span>{{ filterDateRange.from | moment('ddd, MMM Do YYYY') }}</button></div>
            <div class="sbtnwrap"><button class="stmnt-btn datebtn" :class="{ 'active': filterVisiblePicker === 'to' }" @click="selectPicker('to')"><span class="headhint">{{ $t('Statement.daterange.to') }}</span>{{ filterDateRange.to | moment('ddd, MMM Do YYYY') }}</button></div>
          </div>
        </div>
        <v-date-picker v-if="filterDateRange.from && filterVisiblePicker === 'from'" v-model="filterDateRange.from" :show-current="filterDateRange.to" :full-width="true" :no-title="true" :max="filterDateRange.to" :event-color="calcPickerRangeDate" :events="calcPickerRangeDate"></v-date-picker>
        <v-date-picker v-if="filterDateRange.from && filterVisiblePicker === 'to'" v-model="filterDateRange.to" :show-current="filterDateRange.from" :full-width="true" :no-title="true" :min="filterDateRange.from" :max="new Date() | moment('YYYY-MM-DD')" :event-color="calcPickerRangeDate" :events="calcPickerRangeDate"></v-date-picker>
        <div class="fdr-footer">
          <div class="stmnt-btnset x2 fullw">
            <div class="sbtnwrap"><button class="stmnt-btn sb-white" @click="selectPicker('none')"><span>{{ $t('Statement.dialog.Close') }}</span></button></div>
            <div class="sbtnwrap"><button class="stmnt-btn sb-blue" @click="applyPickers('from')"><span>{{ $t('Statement.dialog.Apply') }}</span></button></div>
          </div>
        </div>
      </div>
    </div>

    <div class="stmnt-bbquote" v-if="isLoggedIn && bb && bb.bet && bb.bet.SB && (!bbStatus || bbStatus.state !== 'quoting')">
      <div class="bbq-wrap">
        <div class="block bbq-heading"><span class="text">{{ $t('Statement.CashOutConfirmation')}}</span><span class="bbq-btn bbq-btn-close" @click="cancelBuyBack()">x</span></div>

        <div class="block bbq-info" v-if="bb.bet.Quote !== bb.quote.Amount"><div class="bbq-infomsg bbreoffer">{{ $t('Statement.CashoutReofferNotification') }}</div></div>
        <div class="block bbq-info" v-else><div class="bbq-infomsg stmnt-infocon icblue">{{ $t('Statement.CashOutInfo')}}</div></div>
        <div class="block bethead">
          <div class="betoverview">
            <div class="betttl" v-if="bb.bet.SB && bb.bet.SB.IDFOBetType == 'S'">{{ bb.bet.SB.Legs[0].Event }}</div>
            <div class="betttl" v-else-if="bb.bet.SB && bb.bet.SB.BetTypeExt">{{bb.bet.SB.BetTypeExt}} <span v-if="bb.bet.SB && bb.bet.SB.BetTypeSpread" class="spreadhint">{{bb.bet.SB.BetTypeSpread}} {{ $t('Statement.spreadHint')}}</span></div>
            <div class="betttl" v-else-if="bb.bet.SB && bb.bet.SB.Units && bb.bet.SB.Units > 1">{{bb.bet.SB.BetType}} <span v-if="bb.bet.SB " class="unitshint">x{{bb.bet.SB.Units}} {{ $t('Statement.unitsHint')}}</span></div>
            <div class="betttl" v-else-if="bb.bet.SB">{{bb.bet.SB.BetType}}</div>
            <div class="betrefs" v-if="bb.bet.Status === 'Open'">#{{bb.bet.InvoiceSlip}} - {{ bb.bet.Created | date("yyyy-MM-ddThh:mm:ss") | moment(dateFormats.longDateTime) }}</div>
          </div>
        </div>
        <div class="block betbbquotes">
          <div class="betbbquote">Cash Out Value <span class="money" :class="{ 'blink blink-orange': bb.bet.Quote !== bb.quote.Amount }">{{ bb.quote.Amount | currency}}</span></div>
          <div class="betbbquote">Potential Returns <span v-if="bb.bet.SB.Potential && bb.bet.SB.Potential > 0" class="money">{{ bb.bet.SB.Potential | currency }}</span><span v-else  class="money">-</span></div>
        </div>

        <div class="block" v-if="!isGeolocated && isLoggedIn">
          <div class="bbq-infomsg notgeolocated">
            <p>{{ $t('BetSlip.notLocated.' + state)}}</p>
            <p>{{ $t('BetSlip.tryAgain.' + state)}}</p>
          </div>
        </div>
        <div class="block buyback" v-else>
          <button class="stmnt-btn sb-blue" @click="settleBuyBack(bb.bet.SB.IDFOBet, bb.bet)">{{ $t('Statement.CashOutConfirmCashout')}}</button>
          <div class="bb-loading" v-if="bbStatus && (bbStatus.state === 'settling' || bbStatus.state === 'quoting')"><circle-loader></circle-loader></div>
        </div>
      </div>
    </div>
    <div class="stmnt-bbstatemsg" v-if="isLoggedIn && bb && bb.msg" @click="cancelBuyBack()">
      <div class="msg stmnt-infocon" :class="' msg-' + bb.msgtype +' stmnt-infocon-' + bb.msgtype">{{ bb.msg }}</div>
    </div>

    <div class="stmnt-notif" v-if="(filterVisiblePicker == 'none') && !(historyStatus && historyStatus.fetching === true) && (!isLoggedIn || !history || history.length < 1)">

      <div v-if="history && history.length === 0 && selectedState === 'Open'" class="stmnt-block note"><span class="main">{{ $t('Statement.NoOpenRecordsToShow')}}</span></div>
      <div v-else-if="history && history.length === 0" class="stmnt-block note">
        <span class="main">{{ $t('Statement.NoSettledRecordsToShow')}}</span>
      </div>

      <div class="stmnt-ctrls" v-else-if="history && history.length === 0">
        <button class="btn sb-blue" @click="gotoLiveBetting()"><span class="btn__content">{{ $t('Statement.GoToLiveBetting')}}</span></button>
      </div>
    </div>

    <div class="stmnt-bets" v-if="isLoggedIn && filterVisiblePicker == 'none'">
      <div v-for="bet in history" class="stmnt-bet" :class="'betstatus-' + bet.statusInner + (bet.SB && bet.SB.IDFOBet === bb.idfobet && bb.msgtype === 'nok' ? ' error-outline' : '')">
        <div class="block bethead">
          <div class="betoverview" :class="{'single' : bet.SB && bet.SB.IDFOBetType == 'S'}">
            <div class="betttl whitetitle" v-if="bet.SB && bet.SB.IDFOBetType == 'S'">
              <!-- {{bet.SB.BetType}} renaming Single to Straight--><span>{{ $t('BetSlip.tab.title.Single')}}</span>
            </div>
            <div class="betttl whitetitle" v-else-if="bet.SB && bet.SB.BetTypeExt">{{bet.SB.BetTypeExt}} <span v-if="bet.SB && bet.SB.BetTypeSpread" class="spreadhint">{{bet.SB.BetTypeSpread}} {{ $t('Statement.spreadHint')}}</span></div>
            <div class="betttl whitetitle" v-else-if="bet.SB && bet.SB.Units && bet.SB.Units > 1">{{bet.SB.BetType}} <span v-if="bet.SB " class="unitshint">x{{bet.SB.Units}} {{ $t('Statement.unitsHint')}}</span></div>
            <div class="betttl whitetitle" v-else-if="bet.SB">{{bet.SB.BetType}}</div>
            <div class="betrefs_align">
              <div class="betrefs" v-if="bet.Status === 'Open'">#{{bet.InvoiceSlip}} - {{ bet.Created | date("yyyy-MM-ddThh:mm:ss") | moment(dateFormats.longDateTime) }}</div>
              <div class="betrefs" v-else>#{{bet.InvoiceSlip}} - {{ bet.Created | date("yyyy-MM-ddThh:mm:ss") | moment(dateFormats.longDateTime) }}</div>
            </div>
          </div>
        </div>

        <div class="block leg" :class="'legstatus-'+(leg.Status ? leg.Status.toLowerCase() : 'xx')" v-for="leg in bet.SB.Legs">
          <div class="betsporticon"><icon :name="`icon-${ (leg.IDFOSportType.split(' ').join('').toLowerCase()) || 'empty' }`"></icon></div>
          <div class="leginfo" :class="{ 'leginfo-live': bet.SB && bet.SB.BetState == 'O' && liveEvents.filter(ev => ev.idfoevent == leg.IDFOEvent).length > 0 }">
            <div class="leginfo-top" v-if="bet.SB && bet.SB.IDFOBetType == 'S'">
              <span v-if="bet.Status === 'Won'" class="pd-icon pd-icon-top-prize-pool"></span>
              <span v-if="bet.Status === 'Lost'" class="pd-icon pd-icon-sad-chip"></span>
              <span v-if="bet.statusInner === 'boughtback'" class="pd-icon pd-icon-cashout-bet"></span>
              {{ bet.SB.Legs[0].Event }}
            </div>
            <div class="leginfo-top" v-else>
              <span v-if="bet.Status === 'Won'" class="pd-icon pd-icon-top-prize-pool"></span>
              {{ leg.Event }}
            </div>
            <div class="leginfo-main">
              <span class="leginfo-stats"><div class="leginfo-odds" v-if="leg.PriceUp && leg.PriceDown">{{leg | formatOdds}}</div></span>{{ leg.SelectionExt }}
            </div>
            <div class="leginfo-sub">{{ leg.Market }}</div>
            <div class="legribbon legribbon-void" v-if="bet.SB && bet.SB.BetState != 'O' && leg.Status && leg.Status.toLowerCase() === 'void'">void</div>
            <div class="legliveicon" v-if="bet.SB && bet.SB.BetState == 'O' && liveEvents.filter(ev => ev.idfoevent == leg.IDFOEvent).length > 0"> LIVE</div>
          </div>
        </div>

        <div class="block result">
          <div class="betodds" :class="{ 'hidden': bet.SB && !bet.SB.Odds }">
            <span class="hint">{{ $t('BetSlip.oddsprice') }}</span>
            <div v-if="bet.SB && bet.SB.Odds && bet.SB.Odds !== 0" class="value">{{bet.SB | formatOdds}}</div>
            <div v-else class="value">&nbsp;</div>
          </div>
          <div class="betstake">
            <span class="hint">Bet Amount</span>
            <div class="value">
              <span v-if="bet.SB.Stake">{{bet.SB.Stake | currency}}</span>
              <span v-else>-</span>
            </div>
          </div>
          <div class="betreturn" :class="bet.Status">
            <div class="content-wrapper">
              <span v-if="bet.Status === 'Open' && bet.SB && bet.SB.Potential && bet.SB.Potential > 0" class="hint">{{ $t('Statement.MaxWin')}}</span>
              <span v-else-if="bet.statusInner === 'boughtback'" class="hint">{{ $t('Statement.CASHEDOUT')}}</span>
              <span v-else class="hint">{{ $t('Statement.' + bet.StatusText)}}</span>
              <div class="value">
                <span v-if="bet.Status === 'Open' && bet.SB && bet.SB.Potential && bet.SB.Potential > 0 && bet.SB.Stake">{{ (bet.SB.Potential - bet.SB.Stake) | currency }}</span>
                <span v-else-if="bet.Status === 'Open'">-</span>
                <span v-else-if="bet.Status === 'Lost'">{{ 0 | currency}}</span>
                <span v-else-if="bet.Status !== 'Open' && bet.SB.Return != null"><span>{{bet.SB.Return | currency}}</span></span>
                <span v-else>-</span>
              </div>
            </div>
          </div>
        </div>
        <div class="block buyback" v-if="bet.Status === 'Open' && bet.SB && bet.Quote && bet.Quote > 0">
          <button class="stmnt-btn sb-green" @click="quoteBuyBack(bet.SB.IDFOBet)">CASH OUT {{bet.Quote | currency}}</button>
          <div class="bb-loading" v-if="bb && bb.bet && bb.bet.SB && bb.bet.SB.IDFOBet === bet.SB.IDFOBet"><circle-loader></circle-loader></div>
        </div>
      </div>

      <div v-if="historyStatus && historyStatus.error && historyStatus.error === 'SessionTimeout'" class="stmnt-block note">{{ $t('Statement.SessionTimeout')}}</div>
      <div v-if="historyStatus && historyStatus.fetching === true" class="stmnt-block loading"><circle-loader></circle-loader></div>

      <div class="stmnt-ctrls" v-if="(!historyStatus || historyStatus.fetching === false) && history && history.length && (pageNumber+1) < pageCount && pageCount > 0">
        <button v-if="(pageNumber+1) < pageCount && pageCount > 0" class="btn" @click="loadMore()"><span class="btn__content">{{ $t('Statement.LoadMoreDown')}}</span></button>
      </div>
      <div v-if="history && history.length" class="note note-pagehint">showing pages 1-{{pageNumber + 1}} of {{pageCount}}</div>
    </div>
  </div>
</template>
<script>
  import store from '@/store'
  import config from '@/config'
  import priceFormat from '@/library/priceFormat'
  import Datepicker from 'vuejs-datepicker'
  import CircleLoader from '@/components/common/CircleLoader'
  import Icon from '@/components/common/Icon'
  import BettingOffer from '@/components/mixins/BettingOffer'

  export default {
    name: 'statement',
    components: {
      Datepicker,
      CircleLoader,
      Icon
    },
    data: () => ({
      filterDateRange: { from: null, to: null },
      filterVisiblePicker: 'none',
      filterIsBuyBackOnly: false,
      historyUpdater4BBId: undefined
    }),
    props: [
      'selectedState'
    ],
    mixins: [
      BettingOffer
    ],
    computed: {
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      isGeolocated () {
        var isGeolocated = store.getters['getGeolocated']
        return typeof isGeolocated !== 'undefined' ? JSON.parse(isGeolocated) : false
      },
      geolocationMessage () {
        return store.getters['overlayState/getGeolocationMessage']
      },
      history () {
        return store.getters['statementState/getHistory']
      },
      historyStatus () {
        return store.getters['statementState/getHistoryStatus']
      },
      historyDateRange () {
        return store.getters['statementState/getHistoryDateRange']
      },
      historyDateRangeFrom () {
        return store.getters['statementState/getHistoryDateRangeFrom']
      },
      historyDateRangeMax () {
        let d = new Date()
        d.setTime(d.getTime() + (24 * 60 * 60 * 1000))
        return d
      },
      pageSize () {
        return store.getters['statementState/getPageSize']
      },
      pageNumber () {
        return store.getters['statementState/getPageNumber']
      },
      pageCount () {
        return store.getters['statementState/getPageCount']
      },
      bb () {
        return store.getters['statementState/getBB']
      },
      bbStatus () {
        return store.getters['statementState/getBbStatus']
      },
      bbRefreshInterval () {
        return config.app.autoconf.BUYBACK_REFRESH_INTERVAL
      },
      state () {
        return window.ctsautoconf.STATE
      }
    },
    methods: {
      togglePickers () {
        if (this.filterVisiblePicker === 'none') {
          let f = this.historyDateRange.from ? this.historyDateRange.from : new Date()
          let t = this.historyDateRange.to ? this.historyDateRange.to : new Date()
          let autoZero = function (val) {
            return val < 10 ? '0' + val : val
          }
          this.filterDateRange.from = f.getFullYear() + '-' + autoZero(f.getMonth() + 1) + '-' + autoZero(f.getDate())
          this.filterDateRange.to = t.getFullYear() + '-' + autoZero(t.getMonth() + 1) + '-' + autoZero(t.getDate())
          this.filterVisiblePicker = 'from'
          if (document.querySelector('.mobile_betslip')) {
            document.querySelector('.mobile_betslip').style.zIndex = 200
          }
        } else {
          this.filterVisiblePicker = 'none'
          if (document.querySelector('.mobile_betslip')) {
            document.querySelector('.mobile_betslip').style.zIndex = 1
          }
        }
      },
      selectPicker (picker) {
        if (['from', 'to', 'none'].includes(picker)) {
          this.filterVisiblePicker = picker
        }
        if (document.querySelector('.mobile_betslip')) {
          if (picker !== 'none') {
            document.querySelector('.mobile_betslip').style.zIndex = 200
          } else {
            document.querySelector('.mobile_betslip').style.zIndex = 1
          }
        }
      },
      applyPickers () {
        let drFroms = this.filterDateRange.from.split('-')
        let drTos = this.filterDateRange.to.split('-')
        if (drFroms.length === 3 && drTos.length === 3) {
          let drFromDate = new Date(drFroms[0], parseInt(drFroms[1] - 1), drFroms[2], 0, 0, 1)
          let drToDate = new Date(drTos[0], parseInt(drTos[1] - 1), drTos[2], 23, 59, 59)
          let newHistoryDateRange = { from: drFromDate, to: drToDate }
          store.dispatch('statementState/changeHistoryDateRange', newHistoryDateRange)
        }
        this.fetchHistory(0)
        this.selectPicker('none')
      },
      calcPickerRangeDate (date) {
        let dF = null
        if (this.filterDateRange.from !== null && this.filterDateRange.from.split('-').length === 3) {
          let fs = this.filterDateRange.from.split('-')
          dF = new Date(fs[0], parseInt(fs[1] - 1), fs[2], 0, 0, 1)
        } else if (this.historyDateRange && this.historyDateRange.from) { dF = this.historyDateRange.from }

        let dT = null
        if (this.filterDateRange.to !== null && this.filterDateRange.to.split('-').length === 3) {
          let ts = this.filterDateRange.to.split('-')
          dT = new Date(ts[0], parseInt(ts[1] - 1), ts[2], 23, 59, 59)
        } else if (this.historyDateRange && this.historyDateRange.to) { dT = this.historyDateRange.to }

        const [dY, dM, dD] = date.split('-')
        let d = new Date(dY, parseInt(dM) - 1, dD)
        if (d && dF !== null && dT !== null) {
          if (dF.getFullYear() === dT.getFullYear() && dF.getMonth() === dT.getMonth() && dF.getDate() === dT.getDate()) {
            return false
          } else if (d.getFullYear() === dF.getFullYear() && d.getMonth() === dF.getMonth() && d.getDate() === dF.getDate()) {
            return 'range-start'
          } else if (d.getFullYear() === dT.getFullYear() && d.getMonth() === dT.getMonth() && d.getDate() === dT.getDate()) {
            return 'range-end'
          } else if (d.getTime() > dF.getTime() && d.getTime() < dT.getTime()) {
            return 'range-in'
          }
        }

        return false
      },
      toggleBuybackFilter () {
        this.filterIsBuyBackOnly = this.filterIsBuyBackOnly === false
        this.selectPicker('none')
        let pageNum = 0
        this.fetchHistory(pageNum)
      },
      quoteBuyBack (idfobet) {
        store.dispatch('statementState/quoteBuyBack', {
          idfobet: idfobet
        })
      },
      settleBuyBack (idfobet, bet) {
        store.dispatch('statementState/settleBuyBack', {
          idfobet: idfobet
        }).then(() => {
        }).catch(() => {
        })
      },
      cancelBuyBack () {
        store.dispatch('statementState/cancelBuyBack', {})
      },
      loadInitial () {
        console.log('Initial load')
        this.selectPicker('none')
        let pageNum = 0
        this.fetchHistory(pageNum)
      },
      loadMore () {
        let pageNum = this.pageNumber
        if (pageNum < this.pageCount) { pageNum++ }
        this.fetchHistory(pageNum)
      },
      fetchHistory (pageNum) {
        let pDateFrom = null
        let pDateto = null
        let pPageNumber = pageNum
        let pQueryType = this.queryType
        let pQueryStatus = this.selectedState
        let pQueryBB = this.filterIsBuyBackOnly

        if (this.historyDateRange.from && this.historyDateRange.to) {
          pDateFrom = this.historyDateRange.from
          pDateto = this.historyDateRange.to
        }

        store.dispatch('statementState/fetchHistory', {
          dateFrom: pDateFrom,
          dateTo: pDateto,
          pageNumber: pPageNumber,
          queryType: pQueryType,
          queryStatus: pQueryStatus,
          queryBB: pQueryBB
        })
      },
      fetchHistoryUpdate4BB () {
        store.dispatch('statementState/fetchHistoryUpdate4BB', {})
      },
      canHaveReturn (bet) {
        let priceTypeNilifiers = ['SP', 'FP', 'WPD', 'PPD', 'SPD', 'T1', 'T2', 'T3']
        bet.SB.Legs.forEach(function (leg) {
          if (priceTypeNilifiers.includes(leg.IDFOPriceType) || !leg.PriceDown || !leg.PriceUp) return false
        })
        return true
      },
      gotoLiveBetting () {
        this.$router.push({name: 'sports-live', params: { }})
      },
      extractSportsFromBet (bet) {
        let sports = []
        if (bet && bet.SB && bet.SB.Legs) {
          bet.SB.Legs.forEach(function (leg) {
            if (sports.indexOf(leg.IDFOSport) === -1) {
              sports.push(leg.IDFOSport)
            }
          })
        }
        return sports.join(',')
      }
    },
    filters: {
      formatOdds (node) {
        if (!isNaN(parseFloat(node.Odds)) || (!isNaN(parseFloat(node.PriceUp)) && !isNaN(parseFloat(node.PriceDown)))) {
          let price = !isNaN(parseFloat(node.Odds)) ? ((node.Odds - 1) * node.Units + 1) : ((node.PriceDown + node.PriceUp) / node.PriceDown)
          // precision 0 decimal spaces for SB.price (for singles)
          let precision = !isNaN(parseFloat(node.Odds)) ? 0 : 0
          return priceFormat.formatOdds(price, precision)
        } else {
          return undefined
        }
      },
      date (value, format) {
        if (!value) { return '' }
        var dt, d, t, i
        var leadZero = function (val) { return val.length < 2 ? '0' + val : val }
        var el = { 'yyyy': null, 'MM': null, 'M': null, 'dd': null, 'd': null, 'hh': null, 'h': null, 'mm': null, 'm': null, 'ss': null, 's': null, 'ap': null }

        var e = function (d, t) {
          el.yyyy = d[2]
          el.MM = d[1]
          el.MM = leadZero(el.MM)
          el.MM = leadZero(el.MM)
          el.M = (el.MM * 1).toString()
          el.dd = d[0]
          el.dd = leadZero(el.dd)
          el.d = (el.dd * 1).toString()
          el.hh = t[0]
          el.hh = leadZero(el.hh)
          el.h = el.hh === '12' ? el.hh : (el.hh * 1) % 12
          el.mm = t[1]
          el.mm = leadZero(el.mm)
          el.m = (el.mm * 1).toString()
          el.ss = t[2]
          el.ss = leadZero(el.ss)
          el.s = (el.ss * 1).toString()
          el.ap = el.hh * 1 < 12 ? 'AM' : 'PM'
        }
//        console.log('date value: ' + value)
        if (value.length === 8) {
          e([value.slice(0, 2), value.slice(2, 4), value.slice(4)], [0, 0, 0])
        } else if (value.indexOf('T') > -1) {
          dt = value.split('T')
          d = dt[0].split('-')
          t = dt[1].split(':')
          e([d[2], d[1], d[0]], [t[0], t[1], t[2]])
        } else {
          dt = value.split(' ')
          d = dt[0].split('-')
          t = dt[1].split('-')
          e([d[0], d[1], d[2]], [t[0], t[1], t[2]])
        }
        for (i in el) { format = format.replace(new RegExp(i, 'g'), el[i]) }
        return format
      }
    },
    created () {
      if (this.historyUpdater4BBId) {
        clearInterval(this.historyUpdater4BBId)
        this.historyUpdater4BBId = undefined
      }
      if (config.app.autoconf.BUYBACK_REFRESH_INTERVAL > 1) {
        let refreshInterval = (config.app.autoconf.BUYBACK_REFRESH_INTERVAL * 1000) + 1000
        this.historyUpdater4BBId = setInterval(() => { this.fetchHistoryUpdate4BB() }, refreshInterval)
      }
    },
    watch: {
      $route (to, from) {
        this.filterVisiblePicker = 'none'
      }
    },
    // mounted () { },
    // activated () { },
    // beforeUpdate () { },
    beforeDestroy () {
      if (this.historyUpdater4BBId) {
        clearInterval(this.historyUpdater4BBId)
        this.historyUpdater4BBId = undefined
      }
    },
    destroyed () {
      store.dispatch('statementState/clearHistory')
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/css/config'

  .stmnt { color:#1f375b;  font-weight: normal; overflow: hidden; margin:0; border-radius:5px; }
  .stmnt .note { text-align: center; }
  .stmnt .note .main { display:block; clear:both; color: #2a77aa ; font-size: large; font-weight:normal; font-size: 18px }
  .stmnt .note .hint { display:block; clear:both; color: #2a77aa ; font-size: 14px; }
  .stmnt .note .hint .clickable { color:#1493ff; }
  .stmnt .note.note-pagehint { margin:0; padding:0; color: transparent; }
  .stmnt .linkbut { border:none 0; background:transparent; padding:2px 4px; margin:0 auto; color: #0090ff; cursor: pointer; }
  .stmnt .hidden { visibility:hidden }

  .stmnt-block { padding: 10px; }

  .stmnt .loading { margin: 0; text-align:center; }
  .stmnt .loading .spinner { margin: 0 auto; }

  .stmnt > .head { background: #fff; padding: 5px; }
  .stmnt > .head .inhead { padding:0 8px; line-height:38px; position:relative; border-radius:2px; border: solid 1px #fff; }
  .stmnt > .head .inhead.bordered { border-color: #cfd6dB; }
  .stmnt .inhead .minittl { font-size:10px; line-height:10px; text-transform:uppercase; display:block; position:relative; bottom:-6px; }
  .stmnt .inhead .ttl { font-weight: bold; font-size:larger; }
  .stmnt .inhead .ttl.stmnt-infocon { padding-left:25px; background-position:0 center; }
  .stmnt .inhead .ttl.filtertgl { display:block; padding-right:25px; }
  .stmnt .inhead .minittl + .ttl { line-height:28px; }
  .stmnt .inhead .filterbbtgl { float:right; margin-top: 6px; }

  .stmnt-fentry {
    padding: 5px 0 5px 10px;
  }
  .stmnt-fentry * { vertical-align: middle; }
  .stmnt-fentry label { cursor: pointer; }


  .stmnt-btn.datebtn { background-color: #fff; color: #111; border-color: #cfd6db; line-height:32px; text-align:left; padding-left:12px; padding-right:6px; }
  .stmnt-btn.datebtn.active { border-color: #1493ff; }
  .stmnt-btn.datebtn.active .headhint { color: #1493ff; }
  .stmnt-btn.datebtn .headhint { display:block; font-size:10px; line-height:12px; text-transform:uppercase; position:relative; bottom:-6px; }

  .stmnt-fdaterang { z-index:101; position:absolute; top:0; right:0; bottom:0; left:0; background-color:rgba(0,0,0,.8); }
  .stmnt-fdaterang > span { display: inline-block; }
  .stmnt-fdaterang .fdr-wrap { position:absolute; right:0; bottom:0; left:0; border-top-right-radius:10px; border-top-left-radius:10px; background-color: #fff; z-index:102; }
  .stmnt-fdaterang .fdr-heading { margin:0 5px; padding: 10px 5px; text-align:left; font-size:larger; }
  .stmnt-fdaterang .fdr-footer { margin:0 5px; padding: 10px 5px; text-align:left; font-size:larger; }

  .stmnt-fdaterang .date-picker-table > table { width: 100%; }

  .stmnt-bbquote { z-index:101; position:absolute; top:0; right:0; bottom:0; left:0; background-color:rgba(0,0,0,.8); }
  .stmnt-bbquote .bbq-wrap { position:absolute; right:0; bottom:0; left:0; border-top-right-radius:10px; border-top-left-radius:10px; background-color: #fff; z-index:102; }
  .stmnt-bbquote .block { padding:10px; }
  .stmnt-bbquote .block.bethead,
  .stmnt-bbquote .block.betbbquotes { border-top: solid 1px #CFD6DB; }
  .stmnt-bbquote .block.bbq-info { padding-top:0; }
  .stmnt-bbquote .bbq-heading { text-align:left; line-height:30px; position:relative; }
  .stmnt-bbquote .bbq-heading .text { text-transform: uppercase; font-size: 24px; vertical-align:middle; }
  .stmnt-bbquote .bbq-heading .bbq-btn-close { font-size:24px; font-weight: bold; width:30px; text-align:center; display: inline-block; position:absolute; top:10px; right:10px; cursor: pointer; }

  .stmnt-bbquote .bbq-infomsg { border:1px solid #1493ff; border-radius:3px; padding:15px 15px 15px 40px; color:#1493ff; background-color: rgba(20, 147, 255, .1); background-position:13px center; }
  .stmnt-bbquote .bbq-infomsg.notgeolocated { padding-left: 15px; border-color: #e44242; color: #db3f3f; background-color: rgba(228, 66, 66,0.1); }
  .stmnt-bbquote .bbq-infomsg.bbreoffer { padding-left: 15px; border-color: #f99f4a; color: #ea913c; background-color: rgba(249,159,74,0.1); }

  .stmnt-bbquote .betbbquote { text-transform:uppercase; }
  .stmnt-bbquote .betbbquote .money { float:right; font-weight:bold; }
  .stmnt-bbquote .blink.blink-orange {  animation: blinkOrangeBackground 1s; animation-iteration-count: 2; }
  @keyframes blinkOrangeBackground {
      0% { background-color: rgba(249,159,74,0); }
     50% { background-color: rgba(249,159,74,.8); }
    100% { background-color: rgba(249,159,74,0); }
  }

  .stmnt-bbstatemsg { z-index: 101; position: absolute; right: 0; bottom: 0; left: 0; background-color: rgba(0,0,0,0.8); }
  .stmnt-bbstatemsg .msg { padding: 12px 40px; background-color:#fff; }
  .stmnt-bbstatemsg .msg-nok { background-color:#e44242; color:#fff; }
  .stmnt-bbstatemsg .msg-nok.stmnt-infocon { padding-left:37px !important; background-position:12px center; }
  .stmnt-bbstatemsg .stmnt-infocon.msg-nok { }

  .stmnt-bets,
  .stmnt-notif { padding:0 4px; }

  @media mobile-big-and-below {
    .stmnt-bets,
    .stmnt-notif { padding:0 4px; }
  }

  .stmnt-notif { text-align:center; }
  .stmnt-notif .visual { padding-top:10vh; padding-bottom:5vh; min-height:150px; }
  .stmnt-notif .note { min-height:20vh; }

  .stmnt-bet { display:block; clear: both; background: #fff; border: solid 1px #CFD6DB; margin-top:6px; border-radius:5px; overflow: hidden; }
  .stmnt-bet.error-outline { border-color:#e44242; }
  .stmnt-bet .block { padding:10px; border-top: solid 1px #CFD6DB; }
  .stmnt-bet .block.bethead { display:table; width:100%; border-top: none 0; }
  .stmnt-bet .block.bethead > div { display:table-cell; vertical-align:middle; }
  .stmnt-bet .block.bethead .betsporticon { width: 24px; text-align: left; }
  .stmnt-bet .block.bethead .betttl { flex: 3; }
  .stmnt-bet .block.bethead .whitetitle { flex: initial; }
  .stmnt-bet .block.bethead .betrefs_align { flex: 2; }
  .stmnt-bet .block.bethead .betttl,
  .stmnt-bbquote .block.bethead .betttl  { font-weight:bold; }
  .stmnt-bet .block.bethead .betttl .spreadhint,
  .stmnt-bbquote .block.bethead .betttl .spreadhint,
  .stmnt-bet .block.bethead .betttl .unitshint,
  .stmnt-bbquote .block.bethead .betttl .unitshint { font-weight:normal; }
  .stmnt-bet .block.bethead .betrefs,
  .stmnt-bbquote .block.bethead .betrefs { line-height: inherit; }

  .stmnt-bet .betoverview { position: relative; padding-right:31px; }
  .stmnt-bet.betstatus-boughtback .betoverview { padding-right: 90px; }
  .stmnt-bet .betstatusicon { top:0; right: 0; width: 28px; line-height:28px; font-weight:bold; text-transform:uppercase; padding: 0; overflow:hidden; text-align:center; border-radius: 16px; background-color: #CFD6DB; color: #06283b; }
  .stmnt-bet.betstatus-won .betstatusicon { background-color: #2CB459; color:#fff; }
  .stmnt-bet .betliveicon { position:absolute; top:0; right: -1px; font-size:smaller; font-weight:bold; padding: 1px 5px; color: #fff; background-color: #db3f3f; border-radius:3px; }

  .stmnt-bet .block.betinfo { border-top:none 0; }

  .stmnt-bet .leg { display:table; width:100%; }
  .stmnt-bet .leg > div { display:table-cell; vertical-align:top; }
  .stmnt-bet .leg .betsporticon { width: 24px; text-align: left; vertical-align: middle; }
  .stmnt-bet .leginfo { position: relative }
  .stmnt-bet .leginfo-top { font-weight: bold; }
  .stmnt-bet .leginfo-main {}
  .stmnt-bet .leginfo-sub { line-height:100%; color:#818E95; text-transform: uppercase; }
  .stmnt-bet .sub-right { text-align: right; }
  .stmnt-bet .leginfo-stats { float:right; margin-left:5px; white-space:nowrap;line-height:14px; margin-right: 5px;}
  .stmnt-bet .leginfo-stats .leginfo-odds { font-weight:bold; color:#1493ff; }
  // .stmnt-bet .leg.legstatus-won .leginfo-stats:before,
  // .stmnt-bet .leg.legstatus-lost .leginfo-stats:before { content:""; background-color: #cfd6db; color: #06283b; display:inline-block; font-family:Arial; font-weight:normal; font-size:10px; width:16px; text-align:center; vertical-align:top; border-radius:2px; margin-right:6px; }
  // .stmnt-bet .leg.legstatus-won .leginfo-stats:before { content: "W"; background-color:#34b25d; color:#fff; }
  // .stmnt-bet .leg.legstatus-lost .leginfo-stats:before { content:"L"; background-color:#db3f3f; color:#fff; }

  // .stmnt-bet .leg.legstatus-won { background-color:#f5fff8; }
  // .stmnt-bet .leg.legstatus-won .leginfo-top { color: #219848; }
  // .stmnt-bet .leg.legstatus-lost .leginfo-top { color: #ff4f4f; }

  .stmnt-bet .leginfo-live .leginfo-top { padding-right:40px;}
  .stmnt-bet .legliveicon { position:absolute; top:-2px; right: 0; font-weight:bold; padding: 0; overflow:hidden; text-align:center; color: #DB3F3F; }
  .stmnt-bet .legliveicon .dot { font-size:larger; }

  .stmnt-bet .legribbon { position:absolute; top:0; right: -10px; font-weight:bold; padding: 7px 12px; overflow:hidden; color: #818e95; background-color:#fff; border-bottom-left-radius:5px; border-top-left-radius:5px; text-transform: uppercase; }
  .stmnt-bet .legribbon-void { color: #fff; background-color:#818e95; }
  .stmnt-bet .legribbon-boughtback { color: #fff; background-color:#0d7fe1; }

  .stmnt-bet .result { display:table; width:100%; background-color:#f0f3f8;}
  .stmnt-bet .result > div { display:table-cell; vertical-align:middle; width: 33.3%; text-align:center; }
  .stmnt-bet .result .value { font-weight: bold; color:#1F375B; white-space: nowrap; }
  .stmnt-bet .result .hint { color:#818E95; text-transform: uppercase; }

  .stmnt-bet.betstatus-won .result .betreturn .value > span { padding: 0px; position:relative; }
  .stmnt-bet.betstatus-won .result .betreturn .value span span { background-color:#99EDB8; padding: 1px 3px; white-space: nowrap; }
  .stmnt-bet.betstatus-lost .result .value { color:#98a3b1; }
  .stmnt-bet.betstatus-lost .result .hint { color:#c4cbd0; }
  .stmnt-bet.betstatus-boughtback .result .betreturn .value span span { background-color:#9ED0FC; padding: 1px 3px; }
  .stmnt-bet.betstatus-boughtback .result .betreturn .hint { color:#0D7FE1; }

  .stmnt .block.buyback { position:relative; }
  .stmnt .buyback .bb-loading { position:absolute; top:0; right:0; bottom:0; left:0; background-color:#fff; }

  .stmnt-bet .buyback { background-color:#f0f3f8; border-top:0 none; text-align:center; }
  .stmnt-bet .result + .buyback { padding-top:0; }

  .stmnt-ctrls { background-color: #fff; padding:0 5px; text-align:center; border:solid 1px #cfd6dB; margin-top:5px; }
  .stmnt-ctrls .btn.sb-blue { background-color:#2396fc; color:#fff; }
  .stmnt-btnset.fullw { width:100%; display:table; }
  .stmnt-btnset.x2 .sbtnwrap { display:table-cell; padding:0 5px; }
  .stmnt-btnset .sbtnwrap:first-child { padding-left:0; }
  .stmnt-btnset .sbtnwrap:last-child { padding-right:0; }
  .stmnt-btnset.x2 .sbtnwrap { width:50%; }

  .stmnt-infocon {  }
  .stmnt-infocon.icblue {  }
  .stmnt-infocon.icwhite {  }


  .stmnt-btn {
    font-weight: bold;
    margin: 0 auto;
    padding: 0 16px;
    border-radius: 2px;
    background-color: #f5f5f5;
    line-height: 40px;
    display: block;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #f5f5f5;
  }
  .stmnt-btn.sb-green { background-color: #3fc369; color: #fff; border-color: #3fc369; }
  .stmnt-btn.sb-blue { background-color: #2a77aa; color: #fff; border-color: #2a77aa; }
  .stmnt-btn.sb-white { background-color: #fff; color: #2a77aa; border-color: #cfd6db; }

  .stmnt-tgl {
    border: 0 none;
    background-color: #f0f3f8;
    text-align:left;
    text-indent:-9999px;
    position:relative;
    width:50px;
    height:28px;
    border-radius:14px;
  }
  .stmnt-tgl:focus { outline:none !important }
  .stmnt-tgl:after{
    content:"";
    position:absolute; top:4px; left:4px;
    display:inline-block; width:20px; height:20px; border-radius:10px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    background-color: #fff;
    transition:ease-in-out .3s;
  }
  .stmnt-tgl:not(.on) { box-shadow: 0 0 1px #bbb; }
  .stmnt-tgl.on { background-color: #3fc369; }
  .stmnt-tgl.on:after{ left: 26px; }


  @media desktop-and-above {
    .clickable { cursor:pointer; }
    .stmnt-btn:hover { background: #0d7fe1 !important; color:#fff !important; }
  }

  @media tablet-and-above {
    .stmnt-fdaterang { min-height: 500px; bottom:auto; }
    .stmnt-fdaterang .fdr-btn:hover { cursor: pointer; }
  }
  @media mobile-big-and-below {
    .stmnt { background-color: #fff; position:relative; height: 100%; }
    .stmnt .note.note-pagehint { display:none; }

    .stmnt-fdaterang { position:fixed; }
    .stmnt-fdaterang .fdr-wrap { bottom:60px; }
    .stmnt-fdaterang .date-picker-table table { width: 100%; }

    .stmnt-bbquote { position: fixed; }
    .stmnt-bbquote .bbq-wrap { bottom:60px; }

    .stmnt-bets { padding-bottom: 70px; /* min-height: 82vh; */ }
    .os-ios .stmnt-bets {padding-bottom: 100px}
  }

  /* iphone X */
  @media only screen and (min-device-width: 375px) and (min-device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .os-ios .notWebView .stmnt-fdaterang .fdr-wrap,
    .os-ios .notWebView .stmnt-bbquote .bbq-wrap  {
      bottom:80px
    }
    .os-ios .stmnt-bets {padding-bottom: 100px}
  }

  /* iphone XR */
  @media only screen and (min-device-width: 414px) and (min-device-height: 896px) and (-webkit-min-device-pixel-ratio: 2) {
    .os-ios .notWebView .stmnt-fdaterang .fdr-wrap,
    .os-ios .notWebView .stmnt-bbquote .bbq-wrap {
      bottom: 80px
    }
    .os-ios .stmnt-bets {padding-bottom: 100px}
  }
  /*Iphone 6,7 Plus*/
  @media only screen and (min-device-width: 414px) and (min-device-height: 736px) {
    .os-ios .notWebView .stmnt-fdaterang .fdr-wrap,
    .os-ios .notWebView .stmnt-bbquote .bbq-wrap {
      bottom: 80px
    }
    .os-ios .stmnt-bets {padding-bottom: 100px}
  }
  @media only screen and (max-width: 340px) {
    .stmnt-bet .betrefs-active { flex: 3; }
  }
</style>



// WEBPACK FOOTER //
// src/components/account/Statement.vue